import axios from "axios";
import { useEffect, useState } from "react";

export const ProductDatabase = (url) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const produtosApi = async () => {
     try {
      const resp = await axios.get(url)
      // console.log("Deu certo a requisição", resp.data.content)
      setData(resp.data.content)
     } catch (err) {
      console.log("Deu errado a requisição", err)
     } finally {
      setLoading(false);
     }
    };

    produtosApi();
  }, []);

  return { data, loading };
};
